import { OverlayRef } from '@angular/cdk/overlay';

import { TemplateRef, Type } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Point } from '@angular/cdk/drag-drop';

export interface OverlayCloseEvent<R> {
  type: 'backdropClick' | 'close';
  data: R;
}

// R = Response Data Type, T = Data passed to Modal Type
export class MyOverlayRef<R = any, T = any> {
  afterClosed$ = new Subject<OverlayCloseEvent<R>>();

  private _dragPosition = new BehaviorSubject<Point>({
    x: 0,
    y: 0
  });
  public dragPosition$ = this._dragPosition.asObservable();

  constructor(
    public id: number,
    public title: string,
    public overlay: OverlayRef,
    public content: string | TemplateRef<any> | Type<any>,
    public data: T // pass data to modal i.e. FormData
  ) {}

  moveToFront(document: Document) {
    const overlays = document.getElementsByClassName('my-overlay');

    for (let i = 0; i < overlays.length; i++) {
      const overlay = overlays.item(i);

      // @ts-expect-error foo
      overlay['style'].zIndex = 'initial';
    }

    const el = document.getElementsByClassName('my-overlay-' + this.id);

    // @ts-expect-error foo
    el.item(0)['style'].zIndex = 5000;
  }

  minimize(document: Document) {
    const el = document.getElementsByClassName('my-overlay-' + this.id);

    // @ts-expect-error foo
    el.item(0)['style'].display = 'none';
  }

  maximize(document: Document) {
    const el = document.getElementsByClassName('my-overlay-' + this.id);

    // @ts-expect-error foo
    el.item(0)['style'].display = 'block';

    this.moveToFront(document);
  }

  updatePosition(position: Point) {
    //const el = document.getElementsByClassName('my-overlay-' + this.id);

    //el.item(0)['style'].transform = 'translate3d(0px, 0px, 0px)';

    this._dragPosition.next({
      x: position.x,
      y: position.y
    });
  }

  close(data?: R) {
    // @ts-expect-error foo
    this._close('close', data);
  }

  private _close(type: 'backdropClick' | 'close', data: R) {
    this.overlay.dispose();
    this.afterClosed$.next({
      type,
      data
    });

    this.afterClosed$.complete();
  }
}
